function renderTrustBannerModal() {
  const modal = document.createElement("div");
  let modalBackdrop = document.querySelector(".gz-modal-backdrop");
  modal.classList.add("gz-trust-banner-modal");

  if (modalBackdrop === null) {
    modalBackdrop = document.createElement("div");
    modalBackdrop.classList.add("gz-modal-backdrop");
    document.body.appendChild(modalBackdrop);
  }

  const modalContent = `
    <div class="gz-modal-content">
      <div class="gz-trust-banner-modal-header">
        <h2 id="gz-modal-title">Gazelle Certified Pre-Owned</h2>
      </div>
      <button type="button" class="gz-trust-banner-modal-close close" aria-label="Close">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.1719 2.42188L9.54688 8L15.125 13.5781L15.9219 14.375L14.375 15.9688L13.5781 15.1719L8 9.59375L2.42188 15.1719L1.625 15.9688L0.03125 14.375L0.828125 13.5781L6.40625 8L0.828125 2.42188L0.03125 1.625L1.625 0.03125L2.42188 0.828125L8 6.45312L13.5781 0.875L14.375 0.078125L15.9688 1.625L15.1719 2.42188Z"
            fill="#193154"
          />
        </svg>
      </button>
      <div class="gz-modal-main-content gz-trust-banner-modal-main-content">
        <p>
          All devices sold by Gazelle pass our 55-point comprehensive quality inspection. Here’s a summary of what we check
          for:
        </p>
        <div class="gz-trust-banner-modal-grid">
          <div>
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/battery-orange.png?v=1727469662" alt="" />
            </div>
            <span>Battery health is above 80%</span>
          </div>
          <div>
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/lightning-orange.png?v=1727469662" alt="" />
            </div>
            <span>Buttons, sensors & charging port are all functional</span>
          </div>
          <div>
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/camera-orange.png?v=1727469662" alt="" />
            </div>
            <span>All cameras (front & back) are taking good photos</span>
          </div>
          <div>
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/speaker-orange.png?v=1727469662" alt="" />
            </div>
            <span>Speakers sounds good</span>
          </div>
          <div>
            <div>
              <img src="https://cdn.shopify.com/s/files/1/0011/1411/2060/files/microphone-orange.png?v=1727469662" alt="" />
            </div>
            <span>Microphone works great</span>
          </div>
        </div>
      </div>
    </div>
  `;

  modal.innerHTML = modalContent;

  // Set dialog ARIA attributes once at creation; aria-hidden keeps it out of
  // the accessibility tree until it is actually opened.
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-modal", "true");
  modal.setAttribute("aria-labelledby", "gz-modal-title");
  modal.setAttribute("aria-hidden", "true");

  document.body.appendChild(modal);

  const closeButton = modal.querySelector(".close");
  closeButton.addEventListener("click", () => closeModal());
  modalBackdrop.addEventListener("click", () => closeModal());

  const trustBannerButton = document.querySelectorAll(".gz-trust-banner-modal-link");

  if (trustBannerButton.length !== 0) {
    trustBannerButton.forEach((btn) => {
      btn.addEventListener("click", () => openModal(btn));
      btn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openModal(btn);
        }
      });
    });
  }

  let lastFocusedElement = null;

  function openModal(triggerElement) {
    lastFocusedElement = triggerElement;

    document.body.style.overflow = "hidden";
    modalBackdrop.classList.add("show");
    modal.classList.add("show");

    // Reveal modal to the accessibility tree
    modal.setAttribute("aria-hidden", "false");

    // Activate global focus trap
    trapFocus(modal, closeButton);

    // Add ESC listener
    document.addEventListener("keydown", handleEsc);
  }

  function closeModal() {
    document.body.style.overflow = "";
    modalBackdrop.classList.remove("show");
    modal.classList.remove("show");

    // Hide modal from the accessibility tree when closed
    modal.setAttribute("aria-hidden", "true");

    // Remove global focus trap and return focus
    removeTrapFocus(lastFocusedElement);

    document.removeEventListener("keydown", handleEsc);
  }

  function handleEsc(e) {
    if (e.key === "Escape") {
      closeModal();
    }
  }
}

renderTrustBannerModal();
